import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { ZitadelUser } from "@src/types/user-management";

export interface PostCreateUserResult {
  success: boolean;
  data?: ZitadelUser;
  error?: string;
}

export const postCreateUserUseCase = async (
  user: Partial<ZitadelUser>,
): Promise<PostCreateUserResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.postCreateUser(namespace, user);

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to create user. Please try again later.",
      ).message,
    };
  }
};
